var setToStringTag = require('../internals/set-to-string-tag');

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.math.to-string-tag.js
// module id = 972
// module chunks = 1 2 3 4